import React from 'react'
import styles from './AppWrapperList.module.css'

interface AppWrapperListProps {
  children: React.ReactNode
}

const AppWrapperList: React.FC<AppWrapperListProps> = ({ children }) => {
  return (
    <ul className={styles.list} role="list">
      {children}
    </ul>
  )
}

export default AppWrapperList
